/** Need to get these into the enum */
export const FACET_ACTIONS = 'facet_actions';
export const ROW_CLICK_ACTIONS = 'row_click_actions';
export const TAB_ACTIONS = 'tab_actions';
export const MONITOR_PAGE = 'monitor_page';

export enum RUM_PURPOSE {
  CopyAssist = 'copy_assist',
  Takeover = 'takeover',
  TableColumn = 'table_column',
}
